import React from 'react';
import ReadMoreIcon from 'components/icons/ReadMore';
import CascadingMenuItem from 'components/Menu/CascadingMenuItem';
const readMoreIcon = React.createElement(ReadMoreIcon, null);
// @ts-ignore
const ReadMoreMenuItem = React.forwardRef((props, ref) => {
    return React.createElement(CascadingMenuItem, Object.assign({ ref: ref, icon: readMoreIcon, text: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435" }, props));
});
export default React.memo(ReadMoreMenuItem);
